import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'
import { watch } from 'vue'
import { FeatureIdEnum } from '../../enums/feature-id.enum'
import { useContextQuery } from '../use-context-query'
import { useTagging } from '../use-tagging'

export function useTagExplainSearchAction(): void {
  const { query } = useContextQuery()
  const { taggingAction } = useTagging()

  watch(query, onQueryChange)

  function onQueryChange(): void {
    if (query.value) {
      taggingAction({
        featureId: FeatureIdEnum.EXPLAIN,
        type: EngagementActionsTypeEnum.SEARCH,
      })
    }
  }
}
